import { inject } from 'vue'
import type { InjectionKey, Ref } from 'vue'

export const TableFullscreen: InjectionKey<Ref<boolean>> = Symbol('TableFullscreen')
export const TableInModal: InjectionKey<boolean> = Symbol('TableInModal')

/** Globals wrapper selector of the table a column is rendered in. */
export const TableGlobalsSelector: InjectionKey<string> = Symbol('TableGlobalsSelector')

/** The table a column belongs to; reach it through `useTablePanels`. */
export const TableScope: InjectionKey<string> = Symbol('TableScope')

const DEFAULT_TABLE_GLOBALS_SELECTOR = '.graphql-table-globals-wrapper'

/** Rendered outside a table, the fallback decides where overlays go instead. */
export const useTableGlobalsSelector = (
  fallback: string = DEFAULT_TABLE_GLOBALS_SELECTOR,
): string => inject(TableGlobalsSelector, fallback)
